/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} School_Docenten_Errors_Cannot_Remove_HoofddocentInputs */

const nl_school_docenten_errors_cannot_remove_hoofddocent = /** @type {(inputs: School_Docenten_Errors_Cannot_Remove_HoofddocentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De hoofddocent kan niet worden ontkoppeld. Wijs eerst een andere hoofddocent aan.`)
};

/**

* @param {School_Docenten_Errors_Cannot_Remove_HoofddocentInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const school_docenten_errors_cannot_remove_hoofddocent = /** @type {((inputs?: School_Docenten_Errors_Cannot_Remove_HoofddocentInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<School_Docenten_Errors_Cannot_Remove_HoofddocentInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_school_docenten_errors_cannot_remove_hoofddocent(inputs)
});
export { school_docenten_errors_cannot_remove_hoofddocent as "school.docenten.errors.cannot_remove_hoofddocent" }